import type { MessageSchema } from '@/i18n/types';

const kk: MessageSchema['home'] = {
    loadError:   'Статистика бойынша деректерді жүктеу мүмкін болмады',
    noData:      'Әзірге статистика бойынша деректер жоқ',
    targetLeads: 'Мақсатты лидтер',
};

export default kk;
